import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Clock = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'contour'}>
                <path
                    d='M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <g id={'guts'}>
                <path
                    d='M15.7099 15.18L12.6099 13.33C12.0699 13.01 11.6299 12.24 11.6299 11.61V7.51001'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    Clock,
    'clock',
);
